export default {"src":"/_next/static/media/new-workflow.a4bf8bbe.svg","height":174,"width":310,"blurWidth":0,"blurHeight":0};